import {
  providerRequestsTyped,
  UpdateProviderProfilePayload,
} from "@/api/(requests)/providerTyped";
import { UUID } from "@/core/types";

export async function updateProviderProfile({
  data,
  providerId,
}: {
  data: UpdateProviderProfilePayload;
  providerId?: UUID;
}): Promise<void> {
  return providerRequestsTyped.update_profile({ data, providerId });
}
